import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { PhoneNumber } from '@definedcrowd/Uicomponents';
import { Modal, H2, Button, Typography } from './index';
import { getSpacing, isStringEmpty } from '../utils';
import { savePhoneNumber as savePhoneNumberAction } from '../lib/redux';

const ButtonContainer = styled.div`
  display: flex;
  margin: ${getSpacing('large')} 0 ${getSpacing('large')} 0;
`;

const EditPhoneNumber = ({ phoneNumber, closeModal, savePhoneNumber, onSaveCallback }) => {
  const [isSaving, setIsSaving] = useState(false);
  const [newPhoneNumber, setNewPhoneNumber] = useState(phoneNumber || '');
  const [isFieldInvalid, setIsFieldInvalid] = useState(false);
  const isButtonDisabled = isSaving || isFieldInvalid || isStringEmpty(newPhoneNumber);

  const onSaveClick = async () => {
    setIsSaving(true);
    try {
      await savePhoneNumber(newPhoneNumber);
      closeModal();
      if (onSaveCallback) {
        onSaveCallback();
      }
    } catch (error) {
      setIsSaving(false);
    }
  };

  const translate = key => {
    switch (key) {
      case 'PhoneNumberIsInvalid':
        return 'Invalid phone number';

      case 'PhoneNumberLabel':
      case 'PhoneNumberPlaceholder':
        return 'Your phone number';
      default:
        return '';
    }
  };

  return (
    <Modal toggleModal={closeModal} padding={{ top: 'large', right: 'small', left: 'small' }}>
      <H2 fontWeight={700} margin={{ bottom: phoneNumber ? 'large' : 'xs' }}>
        {phoneNumber ? 'Edit Your Phone Number' : 'Add Phone Number'}
      </H2>

      {!phoneNumber && (
        <Typography margin={{ bottom: 'large' }}>
          In order to start working as an agent, you need to add a valid phone number.
        </Typography>
      )}

      <PhoneNumber
        required={false}
        translate={translate}
        value={newPhoneNumber}
        onChange={({ value, isInvalid }) => {
          setNewPhoneNumber(value);
          setIsFieldInvalid(isInvalid);
        }}
      />

      <ButtonContainer>
        <Button theme="bordered" margin={{ right: 'xs' }} onClick={closeModal}>
          Cancel
        </Button>
        <Button margin={{ left: 'xs' }} disabled={isButtonDisabled} onClick={onSaveClick}>
          {phoneNumber ? 'Save changes' : 'Save'}
        </Button>
      </ButtonContainer>
    </Modal>
  );
};
EditPhoneNumber.propTypes = {
  phoneNumber: PropTypes.string,
  closeModal: PropTypes.func.isRequired,
  savePhoneNumber: PropTypes.func.isRequired,
  onSaveCallback: PropTypes.func
};

EditPhoneNumber.defaultProps = {
  phoneNumber: null,
  onSaveCallback: null
};

function mapDispatchToProps(dispatch) {
  return {
    savePhoneNumber: phoneNumber => dispatch(savePhoneNumberAction(phoneNumber))
  };
}

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(EditPhoneNumber)
);
